const url = 'spending_type';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_SPENDING_TYPE = 'LOADER_SPENDING_TYPE';
const SET_DATA_SPENDING_TYPE = 'SET_DATA_SPENDING_TYPE';
const SET_PAGE_SPENDING_TYPE = 'SET_PAGE_SPENDING_TYPE';
const SET_UPDATE_DATA_SPENDING_TYPE = 'SET_UPDATE_DATA_SPENDING_TYPE';
const SET_BUSCADOR_SPENDING_TYPE = 'SET_BUSCADOR_SPENDING_TYPE';
const SET_FILTRO_SPENDING_TYPE = 'SET_FILTRO_SPENDING_TYPE';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_SPENDING_TYPE, cargando: true});
    const store = getStore();
    const search = store.spending_type.buscador;
    const filtro = store.spending_type.filtro_tipo_gasto;
    let params = {page, search};
    if(filtro){
        params[''] = filtro
    }

    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_SPENDING_TYPE, data});
            dispatch({type: SET_PAGE_SPENDING_TYPE, page});
        }
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_SPENDING_TYPE, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false});
        if(error.statusCode === 404){
            dispatch(push('/spending-types'))
        }
    }).then((data) => {
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false});
        if(data){
            console.log("detail: ", data);
            dispatch({type: SET_UPDATE_DATA_SPENDING_TYPE, updateData: data});
            dispatch(initializeForm('spendingType', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.spendingType.values;
    dispatch({type: LOADER_SPENDING_TYPE, cargando: true})

    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false})
        Swal('Éxito', 'Se ha creado el tipo de gasto.', 'success')
        .then(() => {
            dispatch(push('/spending-types'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.spendingType.values);
    dispatch({type: LOADER_SPENDING_TYPE, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/spending-types'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/roles/create'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_SPENDING_TYPE, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            })
    }).then((data) => {
        dispatch({type: LOADER_SPENDING_TYPE, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_SPENDING_TYPE, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_SPENDING_TYPE, filtro_rol: filtro});
    dispatch(listar(1));
};

export const actions = {
    listar,
    create,
    update,
    detail,
    destroy,
    search,
    filtro,
};

export const reducer = {
    [LOADER_SPENDING_TYPE]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_SPENDING_TYPE]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_SPENDING_TYPE]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_SPENDING_TYPE]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_SPENDING_TYPE]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_SPENDING_TYPE]: (state, { filtro_tipo_gasto}) => {
        return {...state, filtro_tipo_gasto }
    }
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_tipo_gasto: null,
    updateData: {},
};

export default handleActions(reducer, initialState)
